const normalizeImageDimension = (value?: unknown): number | undefined => {
    const dimension = Number(value);

    if (!Number.isFinite(dimension) || dimension <= 0) {
        return undefined;
    }

    return Math.round(dimension);
};

/**
 * Adds the OSS resize and WebP process parameters to avatar URLs.
 * Non-network sources, GIFs, signed URLs and URLs that are already processed
 * must remain unchanged.
 */
export const getAvatarImageSrc = (value?: unknown, width?: unknown, height?: unknown): string => {
    if (typeof value !== 'string' || !value) {
        return '';
    }

    if (/^(?:data|blob):/i.test(value) || /\.gif(?:$|[?#])/i.test(value)) {
        return value;
    }

    if (/[?&]x-oss-process=/i.test(value)) {
        return value;
    }

    if (/[?&]Expires=/i.test(value) && /[?&]OSSAccessKeyId=/i.test(value) && /[?&]Signature=/i.test(value)) {
        return value;
    }

    const hashIndex = value.indexOf('#');
    const url = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
    const hash = hashIndex >= 0 ? value.slice(hashIndex) : '';
    const separator = url.includes('?') ? '&' : '?';
    const normalizedWidth = normalizeImageDimension(width);
    const normalizedHeight = normalizeImageDimension(height);
    const resizeProcess = normalizedWidth && normalizedHeight
        ? `resize,m_fill,w_${normalizedWidth},limit_0/`
        : '';
    const process = `x-oss-process=image/${resizeProcess}format,webp`;

    return `${url}${separator}${process}${hash}`;
};
